type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export default function CheckIcon({
  color = '#000',
  width = 11,
  height = 8,
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.8 2.2071C10.1906 1.81658 10.1906 1.18339 9.8 0.792883C9.40938 0.40238 8.77657 0.402365 8.38594 0.792883L3.94649 5.23223L2.00703 3.29287C1.61641 2.90236 0.983597 2.90235 0.592972 3.29287C0.202347 3.6834 0.202347 4.31658 0.592972 4.70708L3.23946 7.35355C3.63008 7.74405 4.26289 7.74409 4.65352 7.35355L9.8 2.2071Z"
        fill={color}
      />
    </svg>
  );
}
